<ag-shr-need-to-know-modal
  *ngIf="isEditable"
  #needToKnowModalRef
  [title]="editModalOptions?.title ?? 'Need To Know'"
  [isVisibilityTypeLocked]="editModalOptions?.isVisibilityTypeLocked"
></ag-shr-need-to-know-modal>

<ng-container *ngIf="gridState$ | async as gridState">
  <dx-data-grid
    #dataGridRef
    class="need-to-know-grid__data-grid"
    [ngClass]="{ 'need-to-know-grid__data-grid--view': !isEditable }"
    [dataSource]="gridState.dataSource"
    [keyExpr]="BaseModelKeys.dbId"
    [syncLookupFilterValues]="false"
    [showRowLines]="true"
    [showBorders]="true"
    [showColumnLines]="true"
    [columnAutoWidth]="true"
    [wordWrapEnabled]="true"
    [rowAlternationEnabled]="false"
    (onRowRemoving)="onRowRemoving($event)"
    height="100%"
  >
    <dxo-toolbar>
      <dxi-item location="before" [visible]="!!title">
        <div *dxTemplate>
          <div class="toolbar-label">
            <b>{{ title }}</b>
          </div>
        </div>
      </dxi-item>

      <dxi-item
        *ngFor="let toolbarItem of extraToolbarItems"
        [widget]="toolbarItem?.widget"
        [visible]="toolbarItem?.visible ?? true"
        [location]="toolbarItem?.location"
        [options]="toolbarItem?.options"
      >
      </dxi-item>

      <dxi-item
        *ngIf="canCreate && isEditable"
        location="after"
        widget="dxButton"
      >
        <div *dxTemplate>
          <dx-button
            icon="plus"
            [agMergeGuard]="agentDbId"
            (agMergeGuardedClick)="showAddNeedToKnowPopup()"
          ></dx-button>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <dxo-editing mode="popup" [useIcons]="true" [allowUpdating]="false" [allowDeleting]="false" [allowAdding]="false">
    </dxo-editing>
    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-scrolling [mode]="'virtual'" [showScrollbar]="'always'"></dxo-scrolling>

    <dxi-column
      [width]="150"
      [dataField]="BaseModelKeys.createdByAgentDbId"
      [allowEditing]="false"
      caption="Created By"
      cellTemplate="createdByAgentDbIdCellTemplate"
    >
      <dxo-lookup [dataSource]="gridState.createdByLookup" valueExpr="value" displayExpr="description"></dxo-lookup>
      <div *dxTemplate="let cell of 'createdByAgentDbIdCellTemplate'">
        {{ cell.displayValue || cell?.data?.[BaseModelKeys.createdBy] || cell.value }}
      </div>
    </dxi-column>

    <dxi-column
      [width]="150"
      [dataField]="BaseModelKeys.createdDate"
      [allowEditing]="false"
      [dataType]="'date'"
      [sortOrder]="'desc'"
      [format]="dateFormat"
    ></dxi-column>
    <dxi-column [width]="150" [dataField]="NeedToKnowKeys.visibilityLevel">
      <dxo-lookup [dataSource]="needToKnowVisibilityLevelLookup" valueExpr="value" displayExpr="description"></dxo-lookup>
    </dxi-column>
    <dxi-column [dataField]="NeedToKnowKeys.needToKnow"> </dxi-column>

    <dxi-column [visible]="isEditable" cellTemplate="actionsTemplate" [width]="80"></dxi-column>
    <div *dxTemplate="let cell of 'actionsTemplate'" class="d-flex align-items-center">
      <dx-button
        *ngIf="canEdit"
        icon="edit"
        stylingMode="text"
        [agMergeGuard]="agentDbId"
        (agMergeGuardedClick)="showEditPopup({ row: { data: cell.data } })"
      ></dx-button>
      <dx-button
        *ngIf="getIsEditingAllowed({ row: { data: cell.data } }) && canDelete"
        icon="trash"
        stylingMode="text"
        (onClick)="dataGridRef.instance.deleteRow(cell.rowIndex)"
      ></dx-button>
    </div>
  </dx-data-grid>
</ng-container>
